import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Main } from 'src/Routes/Main';

export function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<Main />} />
      </Routes>
    </BrowserRouter>
  );
}
